import { GracePeriodValues } from 'src/utils/constants/distributors';
import {
  adjustTo25IfTodayIsAfter25,
  calculateEndDateFromGracePeriod,
  calculateFirstRentDateFromGracePeriod,
  setGracePeriod
} from 'src/utils/contracts';
import momentLocalTimezone from 'src/utils/momentLocalTimezone';

export default (values, parameter) => {
  if (values.enableMsi) {
    const firstRentDate = adjustTo25IfTodayIsAfter25(
      Number(values.initialPayment) === 0
        ? momentLocalTimezone()
        : momentLocalTimezone().add(1, 'months')
    );

    return {
      ...values,
      startDate: momentLocalTimezone(),
      firstRentDate,
      gracePeriod:
        Number(values.initialPayment) === 0
          ? GracePeriodValues.SAME_DAY_AS_CONTRACT_STARTS
          : GracePeriodValues.ZERO,
      endDate:
        values.endDate ||
        adjustTo25IfTodayIsAfter25(
          calculateEndDateFromGracePeriod(
            momentLocalTimezone(),
            values.term,
            setGracePeriod(values, parameter),
            values.isFirstUpfrontRentModality
          )
        ),
      payday: Math.min(momentLocalTimezone().date(), 25),
      isFirstUpfrontRentModality: false
    };
  }

  return {
    ...values,
    startDate: values.startDate || momentLocalTimezone(),
    firstRentDate:
      values.firstRentDate ||
      adjustTo25IfTodayIsAfter25(
        calculateFirstRentDateFromGracePeriod(
          momentLocalTimezone(),
          setGracePeriod(values, parameter),
          values.isFirstUpfrontRentModality,
          Number(values.initialPayment)
        )
      ),
    secondRentDate:
      values.secondRentDate || momentLocalTimezone().add(2, 'months'),
    gracePeriod:
      values.gracePeriod !== undefined && values.gracePeriod !== null
        ? values.gracePeriod
        : setGracePeriod(values, parameter),
    endDate:
      values.endDate ||
      adjustTo25IfTodayIsAfter25(
        calculateEndDateFromGracePeriod(
          momentLocalTimezone(),
          values.term,
          setGracePeriod(values, parameter),
          values.isFirstUpfrontRentModality
        )
      ),
    payday: values.payday || Math.min(momentLocalTimezone().date(), 25),
    isFirstUpfrontRentModality: values.isFirstUpfrontRentModality
  };
};
